import React from 'react'
import c from 'classnames'

import { scrollHorizontal } from 'utils'
import Button from 'discada/dist/Button'

import './ScrollButtons.scss'

export default function ScrollButtons({
  container,
  className,
  size = 'small',
  invert,
  pixels = 500,
  children,
}) {
  return (
    <div
      className={c('scroll-buttons', 'field has-addons', className, {
        'scroll-buttons-invert': invert,
        'scroll-buttons-small': size === 'small',
        'scroll-buttons-no-kids': !children,
      })}
    >
      <p className="control">
        <Button
          size={size}
          icon="chevron-left"
          onClick={() => scrollHorizontal(container, -1 * pixels)}
          className="scroll-button scroll-button-back"
        />
      </p>
      {children}
      <p className="control">
        <Button
          size={size}
          icon="chevron-right"
          onClick={() => scrollHorizontal(container, pixels)}
          className="scroll-button scroll-button-forward"
        />
      </p>
    </div>
  )
}
